'use client'
import { useAtom } from 'jotai'
import { useTranslation } from 'react-i18next'
import { appErrorAtom } from '@/services/appErrors/appErrorAtom'
import { useErrorMessage } from '@/utils/useErrorMessage'
import { Button } from 'ui/src/components/Button/Button'
import { Dialog } from 'ui/src/components/Dialog/Dialog'
import { FullscreenDialog } from 'ui/src/components/Dialog/FullscreenDialog'
import { Text } from 'ui/src/components/Text/Text'
import { WarningTriangleIcon } from 'ui/src/icons/WarningTriangleIcon'
import { xStack } from 'ui/src/patterns/stack'
import { tokens } from 'ui/src/theme/tokens.css'
import { contentWrapper } from './AppErrorDialog.css'

export const AppErrorDialog = () => {
  const { t } = useTranslation()
  const [lastError, setLastError] = useAtom(appErrorAtom)
  const errorMessage = useErrorMessage(lastError)
  const handleOpenChange = (open: boolean) => {
    if (!open) {
      setLastError(null)
    }
  }

  return (
    <Dialog.Root open={!!lastError} onOpenChange={handleOpenChange}>
      <FullscreenDialog.Modal
        accessibleCloseLabel={t('DIALOG_CLOSE')}
        center={true}
        Footer={
          <>
            <Dialog.Close asChild>
              <Button type="button" variant="primary" size="large" fullWidth={true}>
                {t('ERROR_DIALOG_CLOSE')}
              </Button>
            </Dialog.Close>
          </>
        }
      >
        <div className={contentWrapper}>
          <div className={xStack({ alignItems: 'center', justifyContent: 'center', gap: 'xxs' })}>
            <WarningTriangleIcon size="1em" color={tokens.legacyColors.amber600} />
            <Dialog.Title asChild={true}>
              <Text align="center" size={{ _: 'md', lg: 'lg' }}>
                {t('GENERAL_ERROR_DIALOG_TITLE')}
              </Text>
            </Dialog.Title>
          </div>
          <Text align="center" size={{ _: 'md', lg: 'lg' }} color="textSecondary" balance={true}>
            {errorMessage}
          </Text>
        </div>
      </FullscreenDialog.Modal>
    </Dialog.Root>
  )
}
